import {
  parseSandboxInputsForReoStatuses,
  parseSandboxRequest,
  parseSandboxResponse,
  SandboxInputsForREOStatuses,
  SandboxRequest,
  SandboxRequestREO,
  SandboxResponse,
  SandboxReworkRequest,
} from "@eave/shared/types/api";

import APIClient from "web_modules/APIClient";

export const loadInitialInputs = async (appId: number): Promise<SandboxRequest> => {
  return APIClient.get(`/uw/loan_applications/${appId}/sandbox/inputs`).then((resp: any) =>
    parseSandboxRequest(resp.inputs),
  );
};

export const getInputsForReos = async (
  appId: number,
  reos: SandboxRequestREO[],
): Promise<SandboxInputsForREOStatuses> => {
  return APIClient.post(`/uw/loan_applications/${appId}/sandbox/reo`, { reos }).then((resp: any) =>
    parseSandboxInputsForReoStatuses(resp.reo_calcs),
  );
};

export const submitScenario = async (
  appId: number,
  req: SandboxRequest,
): Promise<SandboxResponse> => {
  return APIClient.post(`/uw/loan_applications/${appId}/sandbox`, req).then((resp: any) =>
    parseSandboxResponse(resp),
  );
};

export const submitRework = async (appId: number, req: SandboxReworkRequest): Promise<{}> => {
  return APIClient.post(`/uw/loan_applications/${appId}/rework_request`, req);
};
